export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const VERIFY_OTP_REQUEST = 'VERIFY_OTP_REQUEST';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAILURE = 'VERIFY_OTP_FAILURE';

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const UPLOAD_CLIENT_MASTER_REQUEST = 'UPLOAD_CLIENT_MASTER_REQUEST';
export const UPLOAD_CLIENT_MASTER_SUCCESS = 'UPLOAD_CLIENT_MASTER_SUCCESS';
export const UPLOAD_CLIENT_MASTER_FAILURE = 'UPLOAD_CLIENT_MASTER_FAILURE';

export const GET_CLIENTS_REQUEST = 'GET_CLIENTS_REQUEST';
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS';
export const GET_CLIENTS_FAILURE = 'GET_CLIENTS_FAILURE';

export const UPDATE_CLIENT_REQUEST = 'UPDATE_CLIENT_REQUEST';
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS';
export const UPDATE_CLIENT_FAILURE = 'UPDATE_CLIENT_FAILURE';

export const DELETE_CLIENT_REQUEST = 'DELETE_CLIENT_REQUEST';
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS';
export const DELETE_CLIENT_FAILURE = 'DELETE_CLIENT_FAILURE';
export const SET_USER = 'SET_USER';

export const UPLOAD_UNIT_MASTER_REQUEST = 'UPLOAD_UNIT_MASTER_REQUEST';
export const UPLOAD_UNIT_MASTER_SUCCESS = 'UPLOAD_UNIT_MASTER_SUCCESS';
export const UPLOAD_UNIT_MASTER_FAILURE = 'UPLOAD_UNIT_MASTER_FAILURE';

export const GET_UNITS_REQUEST = 'GET_UNITS_REQUEST';
export const GET_UNITS_SUCCESS = 'GET_UNITS_SUCCESS';
export const GET_UNITS_FAILURE = 'GET_UNITS_FAILURE';

export const UPDATE_UNIT_REQUEST = 'UPDATE_UNIT_REQUEST';
export const UPDATE_UNIT_SUCCESS = 'UPDATE_UNIT_SUCCESS';
export const UPDATE_UNIT_FAILURE = 'UPDATE_UNIT_FAILURE';

export const DELETE_UNIT_REQUEST = 'DELETE_UNIT_REQUEST';
export const DELETE_UNIT_SUCCESS = 'DELETE_UNIT_SUCCESS';
export const DELETE_UNIT_FAILURE = 'DELETE_UNIT_FAILURE';

export const MULTIDELETE_UNIT_REQUEST = 'MULTIDELETE_UNIT_REQUEST';
export const MULTIDELETE_UNIT_SUCCESS = 'MULTIDELETE_UNIT_SUCCESS';
export const MULTIDELETE_UNIT_FAILURE = 'MULTIDELETE_UNIT_FAILURE';

export const MULTIDELETE_CLIENTUNITS_REQUEST = 'MULTIDELETE_CLIENTUNITS_REQUEST';
export const MULTIDELETE_CLIENTUNITS_SUCCESS = 'MULTIDELETE_CLIENTUNITS_SUCCESS';
export const MULTIDELETE_CLIENTUNITS_FAILURE = 'MULTIDELETE_CLIENTUNITS_FAILURE';

export const SINGLEADD_UNIT_REQUEST = 'SINGLEADD_UNIT_REQUEST';
export const SINGLEADD_UNIT_SUCCESS = 'SINGLEADD_UNIT_SUCCESS';
export const SINGLEADD_UNIT_FAILURE = 'SINGLEADD_UNIT_FAILURE';

export const STATES_CREATE_REQUEST = 'STATES_CREATE_REQUEST';
export const STATES_CREATE_SUCCESS = 'STATES_CREATE_SUCCESS';
export const STATES_CREATE_FAILURE = 'STATES_CREATE_FAILURE';

export const STATES_GET_REQUEST = 'STATES_GET_REQUEST';
export const STATES_GET_SUCCESS = 'STATES_GET_SUCCESS';
export const STATES_GET_FAILURE = 'STATES_GET_FAILURE';

export const STATES_UPDATE_REQUEST = 'STATES_UPDATE_REQUEST';
export const STATES_UPDATE_SUCCESS = 'STATES_UPDATE_SUCCESS';
export const STATES_UPDATE_FAILURE = 'STATES_UPDATE_FAILURE';

export const STATES_DELETE_REQUEST = 'STATES_DELETE_REQUEST';
export const STATES_DELETE_SUCCESS = 'STATES_DELETE_SUCCESS';
export const STATES_DELETE_FAILURE = 'STATES_DELETE_FAILURE';

export const ROLE_CREATE_REQUEST = 'ROLE_CREATE_REQUEST';
export const ROLE_CREATE_SUCCESS = 'ROLE_CREATE_SUCCESS';
export const ROLE_CREATE_FAILURE = 'ROLE_CREATE_FAILURE';

export const ROLE_GET_REQUEST = 'ROLE_GET_REQUEST';
export const ROLE_GET_SUCCESS = 'ROLE_GET_SUCCESS';
export const ROLE_GET_FAILURE = 'ROLE_GET_FAILURE';

export const ROLE_UPDATE_REQUEST = 'ROLE_UPDATE_REQUEST';
export const ROLE_UPDATE_SUCCESS = 'ROLE_UPDATE_SUCCESS';
export const ROLE_UPDATE_FAILURE = 'ROLE_UPDATE_FAILURE';

export const ROLE_DELETE_REQUEST = 'ROLE_DELETE_REQUEST';
export const ROLE_DELETE_SUCCESS = 'ROLE_DELETE_SUCCESS';
export const ROLE_DELETE_FAILURE = 'ROLE_DELETE_FAILURE';

export const GET_USER_ROLE_REQUEST = 'GET_USER_ROLE_REQUEST';
export const GET_USER_ROLE_SUCCESS = 'GET_USER_ROLE_SUCCESS';
export const GET_USER_ROLE_FAILURE = 'GET_USER_ROLE_FAILURE';

export const PERMISSION_CREATE_REQUEST = 'PERMISSION_CREATE_REQUEST';
export const PERMISSION_CREATE_SUCCESS = 'PERMISSION_CREATE_SUCCESS';
export const PERMISSION_CREATE_FAILURE = 'PERMISSION_CREATE_FAILURE';

export const PERMISSION_GET_REQUEST = 'PERMISSION_GET_REQUEST';
export const PERMISSION_GET_SUCCESS = 'PERMISSION_GET_SUCCESS';
export const PERMISSION_GET_FAILURE = 'PERMISSION_GET_FAILURE';

export const PERMISSION_UPDATE_REQUEST = 'PERMISSION_UPDATE_REQUEST';
export const PERMISSION_UPDATE_SUCCESS = 'PERMISSION_UPDATE_SUCCESS';
export const PERMISSION_UPDATE_FAILURE = 'PERMISSION_UPDATE_FAILURE';

export const PERMISSION_DELETE_REQUEST = 'PERMISSION_DELETE_REQUEST';
export const PERMISSION_DELETE_SUCCESS = 'PERMISSION_DELETE_SUCCESS';
export const PERMISSION_DELETE_FAILURE = 'PERMISSION_DELETE_FAILURE';

export const USER_CREATE_REQUEST = 'USER_CREATE_REQUEST';
export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS';
export const USER_CREATE_FAILURE = 'USER_CREATE_FAILURE';

export const USER_GET_REQUEST = 'USER_GET_REQUEST';
export const USER_GET_SUCCESS = 'USER_GET_SUCCESS';
export const USER_GET_FAILURE = 'USER_GET_FAILURE';

export const USER_GET_PROFILE_REQUEST = 'USER_GET_PROFILE_REQUEST';
export const USER_GET_PROFILE_SUCCESS = 'USER_GET_PROFILE_SUCCESS';
export const USER_GET_PROFILE_FAILURE = 'USER_GET_PROFILE_FAILURE';

export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE';

export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_FAILURE = 'USER_DELETE_FAILURE';

export const USER_RESENTMAIL_REQUEST = 'USER_RESENTMAIL_REQUEST';
export const USER_RESENTMAIL_SUCCESS = 'USER_RESENTMAIL_SUCCESS';
export const USER_RESENTMAIL_FAILURE = 'USER_RESENTMAIL_FAILURE';

export const CURRENTMONTH_GET_REQUEST = 'CURRENTMONTH_GET_REQUEST';
export const CURRENTMONTH_GET_SUCCESS = 'CURRENTMONTH_GET_SUCCESS';
export const CURRENTMONTH_GET_FAILURE = 'CURRENTMONTH_GET_FAILURE';

export const CURRENTMONTH_ADD_REQUEST = 'CURRENTMONTH_ADD_REQUEST';
export const CURRENTMONTH_ADD_SUCCESS = 'CURRENTMONTH_ADD_SUCCESS';
export const CURRENTMONTH_ADD_FAILURE = 'CURRENTMONTH_ADD_FAILURE';

export const CREATE_CURRENTMONTH_ADD_REQUEST = 'CREATE_CURRENTMONTH_ADD_REQUEST';
export const CREATE_CURRENTMONTH_ADD_SUCCESS = 'CREATE_CURRENTMONTH_ADD_SUCCESS';
export const CREATE_CURRENTMONTH_ADD_FAILURE = 'CREATE_CURRENTMONTH_ADD_FAILURE';

export const GET_HOLIDAYS_REQUEST = 'GET_HOLIDAYS_REQUEST';
export const GET_HOLIDAYS_SUCCESS = 'GET_HOLIDAYS_SUCCESS';
export const GET_HOLIDAYS_FAILURE = 'GET_HOLIDAYS_FAILURE';

export const UPDATE_HOLIDAYS_REQUEST = 'UPDATE_HOLIDAYS_REQUEST';
export const UPDATE_HOLIDAYS_SUCCESS = 'UPDATE_HOLIDAYS_SUCCESS';
export const UPDATE_HOLIDAYS_FAILURE = 'UPDATE_HOLIDAYS_FAILURE';

export const DELETE_HOLIDAYS_REQUEST = 'DELETE_HOLIDAYS_REQUEST';
export const DELETE_HOLIDAYS_SUCCESS = 'DELETE_HOLIDAYS_SUCCESS';
export const DELETE_HOLIDAYS_FAILURE = 'DELETE_CTC_REGISTER_FAILURE';

export const UPLOAD_HOLIDAYS_REQUEST = 'UPLOAD_HOLIDAYS_REQUEST';
export const UPLOAD_HOLIDAYS_SUCCESS = 'UPLOAD_HOLIDAYS_SUCCESS';
export const UPLOAD_HOLIDAYS_FAILURE = 'UPLOAD_HOLIDAYS_FAILURE';

export const MULTIDELETE_HOLIDAYS_REQUEST = 'MULTIDELETE_HOLIDAYS_REQUEST';
export const MULTIDELETE_HOLIDAYS_SUCCESS = 'MULTIDELETE_HOLIDAYS_SUCCESS';
export const MULTIDELETE_HOLIDAYS_FAILURE = 'MULTIDELETE_HOLIDAYS_FAILURE';

export const GET_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST = 'GET_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST';
export const GET_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS = 'GET_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS';
export const GET_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE = 'GET_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE';

export const UPDATE_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST = 'UPDATE_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST';
export const UPDATE_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS = 'UPDATE_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS';
export const UPDATE_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE = 'UPDATE_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE';

export const DELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST = 'DELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST';
export const DELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS = 'DELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS';
export const DELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE = 'DELETE_CTC_REGISTER_FAILURE';

export const UPLOAD_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST = 'UPLOAD_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST';
export const UPLOAD_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS = 'UPLOAD_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS';
export const UPLOAD_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE = 'UPLOAD_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE';

export const MULTIDELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST = 'MULTIDELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST';
export const MULTIDELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS = 'MULTIDELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS';
export const MULTIDELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE = 'MULTIDELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE';

export const GET_CONTRACTOR_REQUEST = 'GET_CONTRACTOR_REQUEST';
export const GET_CONTRACTOR_SUCCESS = 'GET_CONTRACTOR_SUCCESS';
export const GET_CONTRACTOR_FAILURE = 'GET_CONTRACTOR_FAILURE';

export const UPDATE_CONTRACTOR_REQUEST = 'UPDATE_CONTRACTOR_REQUEST';
export const UPDATE_CONTRACTOR_SUCCESS = 'UPDATE_CONTRACTOR_SUCCESS';
export const UPDATE_CONTRACTOR_FAILURE = 'UPDATE_CONTRACTOR_FAILURE';

export const DELETE_CONTRACTOR_REQUEST = 'DELETE_CONTRACTOR_REQUEST';
export const DELETE_CONTRACTOR_SUCCESS = 'DELETE_CONTRACTOR_SUCCESS';
export const DELETE_CONTRACTOR_FAILURE = 'DELETE_CTC_REGISTER_FAILURE';

export const UPLOAD_CONTRACTOR_REQUEST = 'UPLOAD_CONTRACTOR_REQUEST';
export const UPLOAD_CONTRACTOR_SUCCESS = 'UPLOAD_CONTRACTOR_SUCCESS';
export const UPLOAD_CONTRACTOR_FAILURE = 'UPLOAD_CONTRACTOR_FAILURE';

export const MULTIDELETE_CONTRACTOR_REQUEST = 'MULTIDELETE_CONTRACTOR_REQUEST';
export const MULTIDELETE_CONTRACTOR_SUCCESS = 'MULTIDELETE_CONTRACTOR_SUCCESS';
export const MULTIDELETE_CONTRACTOR_FAILURE = 'CONTRACTOR_FAILURE';

export const GET_QUERY_REPORT_HEADERS_REQUEST = 'GET_QUERY_REPORT_HEADERS_REQUEST';
export const GET_QUERY_REPORT_HEADERS_SUCCESS = 'GET_QUERY_REPORT_HEADERS_SUCCESS';
export const GET_QUERY_REPORT_HEADERS_FAILURE = 'GET_QUERY_REPORT_HEADERS_FAILURE';

export const GET_REPORT_HEADERS_REQUEST = 'GET_REPORT_HEADERS_REQUEST';
export const GET_REPORT_HEADERS_SUCCESS = 'GET_REPORT_HEADERS_SUCCESS';
export const GET_REPORT_HEADERS_FAILURE = 'GET_REPORT_HEADERS_FAILURE';

export const CREATE_REPORT_HEADERS_REQUEST = 'CREATE_REPORT_HEADERS_REQUEST';
export const CREATE_REPORT_HEADERS_SUCCESS = 'CREATE_REPORT_HEADERS_SUCCESS';
export const CREATE_REPORT_HEADERS_FAILURE = 'CREATE_REPORT_HEADERS_FAILURE';

export const UPDATE_REPORT_HEADERS_REQUEST = 'UPDATE_REPORT_HEADERS_REQUEST';
export const UPDATE_REPORT_HEADERS_SUCCESS = 'UPDATE_REPORT_HEADERS_SUCCESS';
export const UPDATE_REPORT_HEADERS_FAILURE = 'UPDATE_REPORT_HEADERS_FAILURE';

export const DELETE_REPORT_HEADERS_REQUEST = 'DELETE_REPORT_HEADERS_REQUEST';
export const DELETE_REPORT_HEADERS_SUCCESS = 'DELETE_REPORT_HEADERS_SUCCESS';
export const DELETE_REPORT_HEADERS_FAILURE = 'DELETE_REPORT_HEADERS_FAILURE';

export const DOWNLOAD_SELECTED_REQUEST = 'DOWNLOAD_SELECTED_REQUEST';
export const DOWNLOAD_SELECTED_SUCCESS = 'DOWNLOAD_SELECTED_SUCCESS';
export const DOWNLOAD_SELECTED_FAILURE = 'DOWNLOAD_SELECTED_FAILURE';

export const GET_ALL_UNITS_REQUEST = 'GET_UNITS_REQUEST';
export const GET_ALL_UNITS_SUCCESS = 'GET_UNITS_SUCCESS';
export const GET_ALL_UNITS_FAILURE = 'GET_UNITS_FAILURE';


export const CREATE_COMPANY_DETAILS_REQUEST = 'CREATE_COMPANY_DETAILS_REQUEST';
export const CREATE_COMPANY_DETAILS_SUCCESS = 'CREATE_COMPANY_DETAILS_SUCCESS';
export const CREATE_COMPANY_DETAILS_FAILURE = 'CREATE_COMPANY_DETAILS_FAILURE';

export const GET_COMPANY_DETAILS_REQUEST = 'GET_COMPANY_DETAILS_REQUEST';
export const GET_COMPANY_DETAILS_SUCCESS = 'GET_COMPANY_DETAILS_SUCCESS';
export const GET_COMPANY_DETAILS_FAILURE = 'GET_COMPANY_DETAILS_FAILURE';

export const UPDATE_COMPANY_DETAILS_REQUEST = 'UPDATE_COMPANY_DETAILS_REQUEST';
export const UPDATE_COMPANY_DETAILS_SUCCESS = 'UPDATE_COMPANY_DETAILS_SUCCESS';
export const UPDATE_COMPANY_DETAILS_FAILURE = 'UPDATE_COMPANY_DETAILS_FAILURE';

export const DELETE_COMPANY_DETAILS_REQUEST = 'DELETE_COMPANY_DETAILS_REQUEST';
export const DELETE_COMPANY_DETAILS_SUCCESS = 'DELETE_COMPANY_DETAILS_SUCCESS';
export const DELETE_COMPANY_DETAILS_FAILURE = 'DELETE_COMPANY_DETAILS_FAILURE';

export const GET_EMPLOYEE_COUNT_REQUEST = 'GET_EMPLOYEE_COUNT_REQUEST';
export const GET_EMPLOYEE_COUNT_SUCCESS = 'GET_EMPLOYEE_COUNT_SUCCESS';
export const GET_EMPLOYEE_COUNT_FAILURE = 'GET_EMPLOYEE_COUNT_FAILURE';

export const GET_LOG_ACTIVITY_REQUEST = 'GET_LOG_ACTIVITY_REQUEST';
export const GET_LOG_ACTIVITY_SUCCESS = 'GET_LOG_ACTIVITY_SUCCESS';
export const GET_LOG_ACTIVITY_FAILURE = 'GET_LOG_ACTIVITY_FAILURE';

export const GET_UPCOMING_HOLIDAYS_REQUEST = 'GET_UPCOMING_HOLIDAYS_REQUEST';
export const GET_UPCOMING_HOLIDAYS_SUCCESS = 'GET_UPCOMING_HOLIDAYS_SUCCESS';
export const GET_UPCOMING_HOLIDAYS_FAILURE = 'GET_UPCOMING_HOLIDAYS_FAILURE';

export const GET_DASHBOARD_FORM_OVERVIEW_REQUEST = 'GET_DASHBOARD_FORM_OVERVIEW_REQUEST';
export const GET_DASHBOARD_FORM_OVERVIEW_SUCCESS = 'GET_DASHBOARD_FORM_OVERVIEW_SUCCESS';
export const GET_DASHBOARD_FORM_OVERVIEW_FAILURE = 'GET_DASHBOARD_FORM_OVERVIEW_FAILURE';

export const USER_PROFILE_UPLOAD_REQUEST = "USER_PROFILE_UPLOAD_REQUEST";
export const USER_PROFILE_UPLOAD_SUCCESS = "USER_PROFILE_UPLOAD_SUCCESS";
export const USER_PROFILE_UPLOAD_FAILURE = "USER_PROFILE_UPLOAD_FAILURE";

export const USER_PROFILE_DELETE_REQUEST = "USER_PROFILE_DELETE_REQUEST";
export const USER_PROFILE_DELETE_SUCCESS = "USER_PROFILE_DELETE_SUCCESS";
export const USER_PROFILE_DELETE_FAILURE = "USER_PROFILE_DELETE_FAILURE";

export const USER_PROFILE_FETCH_REQUEST = "USER_PROFILE_FETCH_REQUEST";
export const USER_PROFILE_FETCH_SUCCESS = "USER_PROFILE_FETCH_SUCCESS";
export const USER_PROFILE_FETCH_FAILURE = "USER_PROFILE_FETCH_FAILURE";


export const GET_ACT_REQUEST = 'GET_ACT_REQUEST';
export const GET_ACT_SUCCESS = 'GET_ACT_SUCCESS';
export const GET_ACT_FAILURE = 'GET_ACT_FAILURE';

export const UPDATE_ACT_REQUEST = 'UPDATE_ACT_REQUEST';
export const UPDATE_ACT_SUCCESS = 'UPDATE_ACT_SUCCESS';
export const UPDATE_ACT_FAILURE = 'UPDATE_ACT_FAILURE';

export const DELETE_ACT_REQUEST = 'DELETE_ACT_REQUEST';
export const DELETE_ACT_SUCCESS = 'DELETE_ACT_SUCCESS';
export const DELETE_ACT_FAILURE = 'DELETE_ACT_FAILURE';

export const UPLOAD_ACT_REQUEST = 'UPLOAD_ACT_REQUEST';
export const UPLOAD_ACT_SUCCESS = 'UPLOAD_ACT_SUCCESS';
export const UPLOAD_ACT_FAILURE = 'UPLOAD_ACT_FAILURE';

export const MULTIDELETE_ACT_REQUEST = 'MULTIDELETE_ACT_REQUEST';
export const MULTIDELETE_ACT_SUCCESS = 'MULTIDELETE_ACT_SUCCESS';
export const MULTIDELETE_ACT_FAILURE = 'MULTIDELETE_ACT_FAILURE';


export const GET_RULE_REQUEST = 'GET_RULE_REQUEST';
export const GET_RULE_SUCCESS = 'GET_RULE_SUCCESS';
export const GET_RULE_FAILURE = 'GET_RULE_FAILURE';

export const UPDATE_RULE_REQUEST = 'UPDATE_RULE_REQUEST';
export const UPDATE_RULE_SUCCESS = 'UPDATE_RULE_SUCCESS';
export const UPDATE_RULE_FAILURE = 'UPDATE_RULE_FAILURE';

export const DELETE_RULE_REQUEST = 'DELETE_RULE_REQUEST';
export const DELETE_RULE_SUCCESS = 'DELETE_RULE_SUCCESS';
export const DELETE_RULE_FAILURE = 'DELETE_RULE_FAILURE';

export const UPLOAD_RULE_REQUEST = 'UPLOAD_RULE_REQUEST';
export const UPLOAD_RULE_SUCCESS = 'UPLOAD_RULE_SUCCESS';
export const UPLOAD_RULE_FAILURE = 'UPLOAD_RULE_FAILURE';

export const MULTIDELETE_RULE_REQUEST = 'MULTIDELETE_RULE_REQUEST';
export const MULTIDELETE_RULE_SUCCESS = 'MULTIDELETE_RULE_SUCCESS';
export const MULTIDELETE_RULE_FAILURE = 'MULTIDELETE_RULE_FAILURE';

export const GET_ACTIVITY_REQUEST = 'GET_ACTIVITY_REQUEST';
export const GET_ACTIVITY_SUCCESS = 'GET_ACTIVITY_SUCCESS';
export const GET_ACTIVITY_FAILURE = 'GET_ACTIVITY_FAILURE';

export const UPDATE_ACTIVITY_REQUEST = 'UPDATE_ACTIVITY_REQUEST';
export const UPDATE_ACTIVITY_SUCCESS = 'UPDATE_ACTIVITY_SUCCESS';
export const UPDATE_ACTIVITY_FAILURE = 'UPDATE_ACTIVITY_FAILURE';

export const DELETE_ACTIVITY_REQUEST = 'DELETE_ACTIVITY_REQUEST';
export const DELETE_ACTIVITY_SUCCESS = 'DELETE_ACTIVITY_SUCCESS';
export const DELETE_ACTIVITY_FAILURE = 'DELETE_ACTIVITY_FAILURE';

export const UPLOAD_ACTIVITY_REQUEST = 'UPLOAD_ACTIVITY_REQUEST';
export const UPLOAD_ACTIVITY_SUCCESS = 'UPLOAD_ACTIVITY_SUCCESS';
export const UPLOAD_ACTIVITY_FAILURE = 'UPLOAD_ACTIVITY_FAILURE';

export const MULTIDELETE_ACTIVITY_REQUEST = 'MULTIDELETE_ACTIVITY_REQUEST';
export const MULTIDELETE_ACTIVITY_SUCCESS = 'MULTIDELETE_ACTIVITY_SUCCESS';
export const MULTIDELETE_ACTIVITY_FAILURE = 'MULTIDELETE_ACTIVITY_FAILURE';

export const GET_TEMPLATE_REQUEST = 'GET_TEMPLATE_REQUEST';
export const GET_TEMPLATE_SUCCESS = 'GET_TEMPLATE_SUCCESS';
export const GET_TEMPLATE_FAILURE = 'GET_TEMPLATE_FAILURE';

export const CREATE_TEMPLATE_REQUEST = 'CREATE_TEMPLATE_REQUEST';
export const CREATE_TEMPLATE_SUCCESS = 'CREATE_TEMPLATE_SUCCESS';
export const CREATE_TEMPLATE_FAILURE = 'CREATE_TEMPLATE_FAILURE';

export const UPDATE_TEMPLATE_REQUEST = 'UPDATE_TEMPLATE_REQUEST';
export const UPDATE_TEMPLATE_SUCCESS = 'UPDATE_TEMPLATE_SUCCESS';
export const UPDATE_TEMPLATE_FAILURE = 'UPDATE_TEMPLATE_FAILURE';

export const DELETE_TEMPLATE_REQUEST = 'DELETE_TEMPLATE_REQUEST';
export const DELETE_TEMPLATE_SUCCESS = 'DELETE_TEMPLATE_SUCCESS';
export const DELETE_TEMPLATE_FAILURE = 'DELETE_TEMPLATE_FAILURE';

export const UPLOAD_TEMPLATE_REQUEST = 'UPLOAD_TEMPLATE_REQUEST';
export const UPLOAD_TEMPLATE_SUCCESS = 'UPLOAD_TEMPLATE_SUCCESS';
export const UPLOAD_TEMPLATE_FAILURE = 'UPLOAD_TEMPLATE_FAILURE';

export const MULTIDELETE_TEMPLATE_REQUEST = 'MULTIDELETE_TEMPLATE_REQUEST';
export const MULTIDELETE_TEMPLATE_SUCCESS = 'MULTIDELETE_TEMPLATE_SUCCESS';
export const MULTIDELETE_TEMPLATE_FAILURE = 'MULTIDELETE_TEMPLATE_FAILURE';